export const wholesaleCategories = [
  {
    id: "wc-001",
    name: "Garden & Outdoor",
    icon: "ri-plant-line",
    productCount: 284,
    minOrder: 6000,
    image: "https://public.readdy.ai/ai/img_res/3380f90a340a054a25d7b6d844f75b50.jpg",
  },
  {
    id: "wc-002",
    name: "Farm & Food",
    icon: "ri-seedling-line",
    productCount: 196,
    minOrder: 6000,
    image: "https://readdy.ai/api/search-image?query=bulk%20wholesale%20organic%20farm%20food%20products%20honey%20maple%20syrup%20olive%20oil%20stacked%20cases%20in%20warehouse%2C%20professional%20product%20photography%2C%20american%20farm%20products%2C%20organized%20bulk%20inventory&width=400&height=300&seq=wcat2&orientation=landscape",
  },
  {
    id: "wc-003",
    name: "Home Goods",
    icon: "ri-home-4-line",
    productCount: 312,
    minOrder: 6000,
    image: "https://readdy.ai/api/search-image?query=bulk%20wholesale%20home%20goods%20kitchen%20products%20cutting%20boards%20candles%20tumblers%20stacked%20in%20warehouse%2C%20professional%20product%20photography%2C%20clean%20background%2C%20organized%20bulk%20inventory&width=400&height=300&seq=wcat3&orientation=landscape",
  },
  {
    id: "wc-004",
    name: "Electronics",
    icon: "ri-cpu-line",
    productCount: 148,
    minOrder: 6000,
    image: "https://readdy.ai/api/search-image?query=bulk%20wholesale%20electronics%20earbuds%20smart%20lamps%20projectors%20stacked%20boxes%20in%20warehouse%2C%20professional%20product%20photography%2C%20clean%20background%2C%20organized%20bulk%20inventory&width=400&height=300&seq=wcat4&orientation=landscape",
  },
];

export const wholesaleProducts = [
  {
    id: "wp-001",
    name: "Steel Raised Garden Bed Kit 4x8ft",
    factory: "American Steel Works LLC",
    location: "Ohio, USA",
    flag: "🇺🇸",
    retailPrice: 89.99,
    wholesalePrice: 54.99,
    minOrderQty: 70,
    minOrderValue: 6000,
    savings: 39,
    category: "Garden",
    inStock: 2400,
    image: "https://readdy.ai/api/search-image?query=heavy%20duty%20galvanized%20steel%20raised%20garden%20bed%20kit%204x8%20feet%20assembled%20outdoors%20with%20soil%20and%20plants%2C%20product%20photography%2C%20clean%20white%20background%2C%20professional%20studio%20lighting%2C%20silver%20metal%20finish&width=400&height=280&seq=wp001&orientation=landscape",
    badge: "Best Seller",
    certifications: ["Made in USA", "ASTM Compliant"],
  },
  {
    id: "wp-002",
    name: "Raw Wildflower Honey 32oz Glass Jar",
    factory: "Golden Prairie Apiary",
    location: "Montana, USA",
    flag: "🇺🇸",
    retailPrice: 18.99,
    wholesalePrice: 10.50,
    minOrderQty: 572,
    minOrderValue: 6006,
    savings: 45,
    category: "Farm Products",
    inStock: 8400,
    image: "https://readdy.ai/api/search-image?query=raw%20wildflower%20honey%20in%20large%20glass%20jar%2032oz%20with%20wooden%20honey%20dipper%20on%20clean%20white%20background%2C%20artisan%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20amber%20color%2C%20natural%20rustic%20label&width=400&height=280&seq=wp002&orientation=landscape",
    badge: "High Demand",
    certifications: ["USDA Organic", "Non-GMO"],
  },
  {
    id: "wp-003",
    name: "Stainless Steel Insulated Tumbler 40oz",
    factory: "HomeStyle Furniture Works",
    location: "Foshan, China → USA Warehouse",
    flag: "🇺🇸",
    retailPrice: 11.99,
    wholesalePrice: 6.20,
    minOrderQty: 968,
    minOrderValue: 6002,
    savings: 48,
    category: "Home Goods",
    inStock: 15000,
    image: "https://readdy.ai/api/search-image?query=stainless%20steel%20insulated%20tumbler%2040oz%20with%20handle%20and%20straw%20on%20white%20background%2C%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20matte%20black%20finish&width=400&height=280&seq=wp003&orientation=landscape",
    badge: "Trending",
    certifications: ["BPA-Free", "FDA Approved"],
  },
  {
    id: "wp-004",
    name: "Professional Bypass Pruning Shears",
    factory: "PowerGarden Tools USA",
    location: "Georgia, USA",
    flag: "🇺🇸",
    retailPrice: 24.99,
    wholesalePrice: 13.80,
    minOrderQty: 435,
    minOrderValue: 6003,
    savings: 45,
    category: "Garden",
    inStock: 6200,
    image: "https://readdy.ai/api/search-image?query=professional%20bypass%20pruning%20shears%20garden%20scissors%20with%20red%20handles%20on%20white%20background%2C%20garden%20tool%20product%20photography%2C%20professional%20studio%20lighting%2C%20sharp%20stainless%20steel%20blades%2C%20ergonomic%20grip&width=400&height=280&seq=wp004&orientation=landscape",
    badge: "Made in USA",
    certifications: ["Made in USA", "ISO 9001"],
  },
  {
    id: "wp-005",
    name: "Vitamin C Brightening Serum 30ml",
    factory: "BeautyGlow Cosmetics Ltd.",
    location: "Shanghai → USA Warehouse",
    flag: "🇺🇸",
    retailPrice: 8.99,
    wholesalePrice: 4.20,
    minOrderQty: 1429,
    minOrderValue: 6002,
    savings: 53,
    category: "Beauty",
    inStock: 22000,
    image: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20face%20serum%20glass%20bottle%20with%20dropper%20on%20white%20background%2C%20skincare%20product%20photography%2C%20minimalist%20style%2C%20professional%20studio%20lighting%2C%20orange%20and%20white%20packaging&width=400&height=280&seq=wp005&orientation=landscape",
    badge: "Top Seller",
    certifications: ["FDA Compliant", "Dermatologist Tested"],
  },
  {
    id: "wp-006",
    name: "Cold-Pressed Extra Virgin Olive Oil 1 Gallon",
    factory: "California Olive Ranch",
    location: "California, USA",
    flag: "🇺🇸",
    retailPrice: 44.99,
    wholesalePrice: 26.50,
    minOrderQty: 227,
    minOrderValue: 6016,
    savings: 41,
    category: "Farm Products",
    inStock: 3800,
    image: "https://readdy.ai/api/search-image?query=extra%20virgin%20olive%20oil%201%20gallon%20tin%20can%20on%20white%20background%2C%20california%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20green%20and%20gold%20label%2C%20premium%20cold%20pressed%20olive%20oil%2C%20american%20grown&width=400&height=280&seq=wp006&orientation=landscape",
    badge: "Award Winning",
    certifications: ["USDA Organic", "COOC Certified"],
  },
];

export const wholesaleTiers = [
  {
    name: "Bronze",
    minOrder: 6000,
    maxOrder: 14999,
    discount: "Up to 40% off retail",
    perks: ["Wholesale pricing", "Priority shipping", "Dedicated account manager"],
    color: "from-amber-700 to-amber-500",
    textColor: "text-amber-700",
    bgColor: "bg-amber-50",
    borderColor: "border-amber-200",
  },
  {
    name: "Silver",
    minOrder: 15000,
    maxOrder: 49999,
    discount: "Up to 50% off retail",
    perks: ["All Bronze perks", "Net-30 payment terms", "Custom labeling available", "Free freight on orders $20K+"],
    color: "from-gray-500 to-gray-400",
    textColor: "text-gray-600",
    bgColor: "bg-gray-50",
    borderColor: "border-gray-300",
    popular: false,
  },
  {
    name: "Gold",
    minOrder: 50000,
    maxOrder: null,
    discount: "Up to 60% off retail",
    perks: ["All Silver perks", "Exclusive product lines", "White-label / OEM options", "Dedicated logistics team", "Net-60 payment terms"],
    color: "from-[#D4AF37] to-[#B8860B]",
    textColor: "text-[#B8860B]",
    bgColor: "bg-[#fdf8f0]",
    borderColor: "border-[#D4AF37]/50",
    popular: true,
  },
];

export const wholesaleStats = [
  { value: "$6,000", label: "Minimum Order", icon: "ri-shopping-bag-3-line" },
  { value: "40-60%", label: "Below Retail Price", icon: "ri-percent-line" },
  { value: "500+", label: "USA Factory Products", icon: "ri-building-2-line" },
  { value: "2-5 Days", label: "USA Delivery", icon: "ri-truck-line" },
];
